module.exports = __webpack_public_path__ + "web/img/sign-80.23eee8ba.png";